<template>
  <div class="row full-width q-col-gutter-md">
    <div v-for="detail in details" :key="detail.label" class="col-6">
      <p class="text-body text-grey-6">{{ detail.label }}</p>
      <p class="text-weight-medium text-grey-8 q-mt-xs">
        {{ detail.value === undefined ? '-' : detail.value }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryDetails',
  props: {
    details: {
      type: Array,
      default: () => []
    }
  }
};
</script>
